import 'babel-polyfill';
import '@/styles/index.scss';
import Vue from 'vue';
import 'locale-compare-polyfill';
import '@/plugins/axios';
import '@/plugins/element-ui';
import '@/plugins/vue-cookie';
import '@/plugins/pluralize';
import '@/plugins/innersvg-polyfill';
import '@/plugins/moment';
import '@/plugins/vue-awesome';
import '@/plugins/in-view';
import '@/plugins/word-cloud';
import '@/plugins/vue-vimeo-player';
import '@/plugins/p5';
import '@/plugins/social-sharing';
import '@/plugins/browser-detection';
import '@/plugins/vue-device-detector';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router/router';
import store from './store/store';

sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
